import React from 'react'

const LoaderSpinner = ({ text, size = 'small', className = '' }) => {
  return (
    <div className={`loader__spinner__container ${className}`}>
      <div className={`loader__spinner ${size}`}></div>
      {text && <p className="loader__spinner__text">{text}</p>}
    </div>
  )
}

export default LoaderSpinner